import { Link } from "react-router-dom";
import images from "../../assets/images/assets";
import Button1 from "../SmallComponents/Button1";

const OrderCardSection = () => {
  return (
    <div className="bg-transparent w-full p-4 text-zinc-700 pb-28 ">
      <div className="bg-transparent p-4 md:p-8 col items-center gap-6 lg:gap-4 text-prime-red">
        {/* Header */}
        <h2 className=" playfair-display  heading-1 relative">
          <img
            src={images.star1}
            alt="decorative"
            className="w-4 absolute left-23 md:left-32 lg:left-[50%] -top-3"
          />
          Order a card
        </h2>

        {/* Story */}
        <p className="montserrat text-center md:w-3/4  indent-2 lg:p-4 lg:w-[50%] ">
          Ready to set the perfect tone for your special event? Order your
          custom invitation cards today and let us craft a memorable first
          impression that reflects the unique spirit of your celebration.
        </p>

        {/* Read More */}
        <Link to="/contact">
          <Button1 title=" Order invitation Card" />
        </Link>
      </div>
    </div>
  );
};

export default OrderCardSection;
